var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenPriceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 727.5 786.3",
    style: {
      enableBackground: "new 0 0 727.5 786.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.7,128.4C156.6,110.3,55.6,95.3,0,96.2l3.4-46.9c64.7-0.6,180,17.2,232.8,41.6L204.7,128.4z M572.2,85.6l155.3,585.3 L293.7,786.3L138.1,205l67.5-75.9c6.6,2.5,13.1,5,19.7,7.8c41.2,17.2,74.1,38.1,95.6,60.3c-11.9,17.2-16.6,39.1-10.9,60.9 c10.3,39.1,50.6,62.5,89.7,51.9c39.1-10.3,62.5-50.6,51.9-89.7c-10.3-39.1-50.6-62.5-89.7-51.9c-0.9,0.3-1.9,0.6-2.5,0.6 c-30-33.1-75-60-122.2-78.8L316.9,0L572.2,85.6z M560.6,552.5c-13.8-51.6-72.5-51.6-98.1-51.9c-48.1-0.6-56.2-15.6-58.1-24.4 c-3.8-20.6,17.2-31.6,38.7-32.5c17.2-0.6,36.3,4.4,47.5,9.1l20.3-42.2c-17.2-5.9-39.1-14.1-67.5-11.9l-9.1-33.4l-43.1,11.6l8.4,32.2 c-40.6,14.4-61.6,47.8-51.9,83.8c9.4,35,39.1,44.7,67.8,50.3c23.8,4.4,85.6-0.6,89.4,26.9c2.2,15-10.6,29.7-36.9,33.4 c-22.8,3.1-51.6-9.1-51.6-9.1l-23.8,40.9c23.8,10.6,47.2,15,70.9,13.4l8.4,31.6l43.1-11.6l-7.8-30 C547.2,622.8,570,586.9,560.6,552.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPriceIcon);
export default __webpack_public_path__ + "static/media/token_price_icon.2e6e6d4f1f1465821cbc34b4bdb32452.svg";
export { ForwardRef as ReactComponent };